import angular from 'angular';

angular.module('myConsultApp').directive('adminHeader', function ($rootScope, $location) {
  return {
    templateUrl: 'templates/v2/admin-header.html',
    restrict: 'A',
    link: function (scope, elem, attr) {
      scope.query = '';
      scope.filterOptions = [
        {
          id: 'Users',
          title: 'Users',
          url: '/admin/users/manage-users',
          isSuperUser: false,
          placeholder: 'Name or Email',
        },
        {
          id: 'Activity Types',
          title: 'Activity Types',
          url: '/admin/loyalty/activities/manage-activity-types',
          isSuperUser: true,
          placeholder: 'Activity Type Name',
        },
        {
          id: 'Organizations',
          title: 'Organizations',
          url: '/admin/organizations/manage-organizations',
          isSuperUser: false,
          placeholder: 'Organization Name or NARC',
        },
        {
          id: 'Pets',
          title: 'Pets',
          url: '/admin/pets/manage-pets',
          isSuperUser: false,
          placeholder: "Pet's Name",
        },
        {
          id: 'Promotion Codes',
          title: 'Promotion Codes',
          url: '/admin/loyalty/activities/manage-promotion-codes',
          isSuperUser: true,
          placeholder: 'Promotion Code',
        },
        {
          id: 'Redemptions',
          title: 'Redemptions',
          url: '/admin/loyalty/reward-redemptions/manage-redemptions',
          isSuperUser: false,
          placeholder: 'User’s Name, Email, or Redemption ID',
        },
        {
          id: 'Rewards',
          title: 'Rewards',
          url: '/admin/loyalty/reward-redemptions/manage-rewards',
          isSuperUser: true,
          placeholder: 'Reward Title, SKU, Contentstack UID, Description',
        },
        {
          id: 'Transactions',
          title: 'Transactions',
          url: '/admin/loyalty/transactions/manage-transactions',
          isSuperUser: false,
          placeholder: "User's Name, Email or Transaction ID",
        },
        {
          id: 'User Activities',
          title: 'User Activities',
          url: '/admin/loyalty/activities/manage-user-activities',
          isSuperUser: false,
          placeholder: "User's Name or Email",
        },
      ];
      scope.matchedOption = scope.filterOptions.filter((option) =>
        $location.url().startsWith(option.url),
      );
      scope.currentOption =
        scope.matchedOption.length === 1 ? scope.matchedOption[0] : scope.filterOptions[0];

      scope.updateFilterOption = function (option) {
        scope.currentOption = option;
        scope.query = '';
        $rootScope.searchText = scope.query;
        $('.filter-dropdown').removeClass('show');
      };
      scope.toggleDropDown = function () {
        $('.filter-dropdown').toggleClass('show');
      };

      scope.searchQuery = function () {
        $rootScope.searchText = scope.query;
        $rootScope.isSearchStarted = true;
        $location.path(scope.currentOption.url);
        $rootScope.$emit('searchEvent', scope.currentOption.id);
      };

      scope.formKeyUp = function (event) {
        if (event.keyCode === 13) {
          scope.searchQuery();
        }
      };

      scope.updateSearchQuery = () => {
        $rootScope.searchText = angular.element('#searchQuery').val();
      };

      angular.element(document).ready(function () {
        $(document).on('click', function (event) {
          var $filter = $('.search-filter');
          if ($filter != event.target && !$filter.has(event.target).length) {
            $('.filter-dropdown').removeClass('show');
          }
        });
      });

      $rootScope.$on('$locationChangeSuccess', function (event, newURL, oldURL) {
        if (newURL != oldURL) {
          if (!newURL.includes(scope.currentOption.url)) {
            var index = scope.filterOptions.findIndex((item) => newURL.includes(item.url));
            index = index == -1 ? 0 : index;
            scope.currentOption = scope.filterOptions[index];
            scope.query = '';
            $rootScope.searchText = scope.query;
          }
        }
      });

      const updateAdminSearchQuery = $rootScope.$on('updateAdminSearchQuery', () => {
        scope.updateSearchQuery();
      });

      scope.$on('$destroy', () => {
        updateAdminSearchQuery();
      });
    },
  };
});
